import { translate } from './I18nContext';

const apiMessageKeyMap = {
  'session expired': 'api.session_expired_title',
  'please login again.': 'api.session_expired_message',
  'please login again': 'api.session_expired_message',
  'security error': 'api.security_error_title',
  'request rejected': 'api.request_rejected',
  'network error': 'api.network_error_title',
  'unable to reach server': 'api.network_error_message',
  'validation failed': 'api.validation_failed',
  'something went wrong': 'api.generic_error'
};

const normalizeApiMessage = (message) => {
  if (!message || typeof message !== 'string') return '';
  return message.trim().toLowerCase();
};

export const getApiMessageKey = (message) => {
  const normalized = normalizeApiMessage(message);
  return apiMessageKeyMap[normalized] || null;
};

export const translateApiMessage = (message, fallbackKey = 'api.generic_error') => {
  const mappedKey = getApiMessageKey(message);

  if (mappedKey) {
    return translate(mappedKey, {}, message || '');
  }

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return translate(fallbackKey, {}, fallbackKey);
};
